import { ReactNode, useCallback, useEffect, useState } from 'react';
import { GsapContext, ImportedGSAP } from './GsapContext';

type Props = {
  children?: ReactNode;
};

export function GsapProvider({ children }: Props) {
  const [imported, setImported] = useState<ImportedGSAP>({});

  const loadGSAP = useCallback(async () => {
    const [gsap, ScrollTrigger] = await Promise.all([
      import('gsap'),
      import('gsap/ScrollTrigger'),
    ]);

    gsap.default.registerPlugin(ScrollTrigger.default);

    setImported({
      gsap: gsap.default,
      ScrollTrigger: ScrollTrigger.default as unknown as ScrollTrigger,
    });
  }, [setImported]);

  useEffect(() => {
    loadGSAP();
  }, [loadGSAP]);

  return (
    <GsapContext.Provider value={imported}>{children}</GsapContext.Provider>
  );
}
